var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      !_vm.initializing && _vm.stat?.data
        ? _c(
            "v-row",
            [
              _c("v-col", { staticClass: "px-4 pb-0", attrs: { cols: "7" } }, [
                _c(
                  "div",
                  {
                    staticClass: "font-weight-bold soli-grey",
                    class: _vm.$vuetify.breakpoint.smAndUp
                      ? "body-2"
                      : "caption",
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.stat?.chartData?.options?.find(
                            (e) => e.key == _vm.selectOption
                          )?.description ?? _vm.stat.data.description
                        ) +
                        "\n            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.stat.data.valid
                  ? _c(
                      "div",
                      {
                        staticClass: "headline flex soli-grey",
                        class: _vm.stat.data.color,
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.stat.data.value) +
                            "\n            "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.stat.data.valid
                  ? _c("div", { staticClass: "pt-2" }, [
                      _c(
                        "small",
                        {
                          staticClass:
                            "flex soli-grey text-align-center font-weight-bold",
                        },
                        [_vm._v("Not enough data")]
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              !_vm.table
                ? _c(
                    "v-col",
                    {
                      staticClass: "pt-4 pl-0 pb-0",
                      class: { invisible: _vm.stat.data.hide_comparisons },
                      staticStyle: { "min-height": "76px" },
                      attrs: { cols: "5" },
                    },
                    _vm._l(_vm.stat.data.comparisons, function (comp) {
                      return _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-col align-end whitespace-no-wrap",
                        },
                        [
                          comp.value
                            ? _c(
                                "small",
                                {
                                  staticClass:
                                    "soli-grey caption flex text-align-end",
                                },
                                [
                                  _vm._v(
                                    _vm._s(comp.value) +
                                      "\n                    "
                                  ),
                                  _c(
                                    "v-icon",
                                    { class: comp.color, attrs: { small: "" } },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(comp.icon) +
                                          "\n                    "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.initializing && !_vm.stat?.data
        ? _c(
            "v-row",
            [
              _c("v-col", { staticClass: "flex justify-center align-center" }, [
                _c(
                  "small",
                  {
                    staticClass: "soli-grey text-align-center font-weight-bold",
                  },
                  [_vm._v("Not enough data")]
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.initializing && !_vm.table && _vm.stat?.data
        ? _c(
            "v-row",
            { staticClass: "mt-0" },
            [
              _c(
                "v-col",
                { staticClass: "pa-0" },
                [
                  _vm.stat.data.chart_view
                    ? _c("AttributeStatsChart", {
                        attrs: {
                          chartData: _vm.stat.chartData,
                          loading: _vm.loading,
                        },
                        on: {
                          reset: function ($event) {
                            return _vm.$emit("reset")
                          },
                          selectOption: function ($event) {
                            return _vm.getData($event)
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.initializing
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  staticClass: "flex justify-center align-center",
                  staticStyle: { "min-height": "304px" },
                },
                [
                  _c("v-progress-circular", {
                    attrs: { indeterminate: "", color: "primary" },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showStatsHelp
        ? _c("SoliResponsiveDialog", {
            attrs: { title: `About ${_vm.stat.data.description}` },
            on: {
              reset: function ($event) {
                return _vm.$emit("reset")
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c(
                        "v-card-text",
                        {
                          staticClass: "pt-0",
                          staticStyle: { "white-space": "pre-line" },
                        },
                        [_vm._v(_vm._s(_vm.stat.data.help))]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2103348555
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }